const products = {
    "Startup Registration": "prod_O8ZUyLNcVJKfUm",
    "Content Access": "prod_OJrKsW6ok34k8q",
    "VC Registration": "prod_Q8zOZXlXVWQLba",
    "Angel Investor Registration": "prod_RHoHYuI9TrhbuR",
};
export default products;
